export const RoleContract  = {
    async index() {
        throw new Error("Index not implemented");
    },
    
    async show(role_id) {
        role_id;
        throw new Error("Show not implemented");
    },

    async create(data) {
        data;
        throw new Error("Create not implemented");
    },

    async update(role_id, data) {
        role_id;
        data;
        throw new Error("update not implemented");
    },

    async delete(role_id) {
        role_id;
        throw new Error("Delete not implemented");
    },
}